// import Vue from 'vue';
import { tansParamsNotEnCode } from '@/utils/index.js';
import md5 from 'md5'
// import { createApp } from 'vue'
import { jsonp } from 'vue-jsonp'

// const vm = new createApp();
function service({ url , params }) { 
    return new Promise((resolve,reject)=>{
        const KEY = "U2GBZ-L6IW6-BZSSX-EUPWF-UUZ7Z-MNB3T";
        const SK = 'AXg587SaXwSfRvaxNusGzUnEsAGpjl7g';
        const callbackName = `callback${new Date().getTime()}`
        params = {
            ...params,
            key:KEY,
            callback:callbackName,
            output: "jsonp"
        }
        let newParams = {};
        Object.keys(params).sort().map(item=>{
            newParams[item] = params[item];
        });
        newParams.sig = md5(`${url}?${tansParamsNotEnCode(newParams).slice(0,-1)+SK}`);
        newParams.callbackName = callbackName;
        jsonp(process.env.VUE_APP_QQMAP_WEB_SERVICE+url,newParams)
        .then((res) => {
            if(res.status!==0) {
                // res.message&&ElMessage({
                //     message: res.message,
                //     type: 'error'
                // })
                reject(res);
            }else resolve(res);
        })
        .catch((err) => {
            window.console.log('err',{ err , url , params })
            // err.message&&ElMessage({
            //     message: err.message,
            //     type: 'error'
            // })
            reject(err);
        });
    })
    
}
export default service